import {Column, Entity} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {GroundSlotTypeEnum} from "@/modules/club-grounds/enums";

@Entity({orderBy: {id: 'ASC'}})
export class GroundSlot extends BaseEntity {
  @Column({type: 'varchar', enum: GroundSlotTypeEnum, nullable: true})
  type?: GroundSlotTypeEnum | null;

  @Column({type: 'boolean'})
  locked = true;

  @Column({type: 'boolean'})
  unlockable = false;

  @Column({type: 'boolean'})
  demolishable = true;

  @Column({type: 'date', nullable: true})
  availableAt?: Date | null;

  @Column({type: 'date', nullable: true})
  demolishAt?: Date | null;

  @Column({type: 'date', nullable: true})
  developedAt?: Date | null;

  @Column({type: 'boolean'})
  available = false;

  @Column({type: 'integer', unsigned: true})
  price: number;
}
